import { mobile } from "../responsive";
import styled from "styled-components";

export const StyledClient = styled.div`
  margin: 1rem 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    font-size: 2rem;
    margin-bottom: 0.7rem;
  }

  form {
    width: 450px;
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
    ${mobile({ width: 350, marginRight: 15 })}
    label {
      font-size: 0.8rem;
      margin: 0;
    }

    input {
      width: 450px;
      ${mobile({ width: 350, marginRight: 15 })}
    }
    p {
      color: "#2797fe";
    }
  }
`;
